export type IconComponentType = React.FunctionComponent<{
	className?: string
	strokeWidth?: string | number
}>

export type Sizes = 'sm' | 'md' | 'lg'

export type BadgeColors =
	| 'gray'
	| 'brand'
	| 'error'
	| 'warning'
	| 'success'
	| 'gray-blue'
	| 'blue-light'
	| 'blue'
	| 'indigo'
	| 'purple'
	| 'pink'
	| 'orange'

export type FlagTypes =
	| 'AD'
	| 'AE'
	| 'AF'
	| 'AG'
	| 'AI'
	| 'AL'
	| 'AM'
	| 'AO'
	| 'AR'
	| 'AS'
	| 'AT'
	| 'AU'
	| 'AW'
	| 'AX'
	| 'AZ'
	| 'BA'
	| 'BB'
	| 'BD'
	| 'BE'
	| 'BF'
	| 'BG'
	| 'BH'
	| 'BI'
	| 'BJ'
	| 'BL'
	| 'BM'
	| 'BN'
	| 'BO'
	| 'BQ-1'
	| 'BQ-2'
	| 'BQ'
	| 'BR'
	| 'BS'
	| 'BT'
	| 'BW'
	| 'BY'
	| 'BZ'
	| 'CA'
	| 'CC'
	| 'CD-1'
	| 'CD'
	| 'CF'
	| 'CH'
	| 'CK'
	| 'CL'
	| 'CM'
	| 'CN'
	| 'CO'
	| 'CR'
	| 'CU'
	| 'CW'
	| 'CX'
	| 'CY'
	| 'CZ'
	| 'DE'
	| 'DJ'
	| 'DK'
	| 'DM'
	| 'DO'
	| 'DS'
	| 'DZ'
	| 'earth'
	| 'EC'
	| 'EE'
	| 'EG'
	| 'EH'
	| 'ER'
	| 'ES'
	| 'ET'
	| 'FI'
	| 'FJ'
	| 'FK'
	| 'FM'
	| 'FO'
	| 'FR'
	| 'GA'
	| 'GB-2'
	| 'GB'
	| 'GD'
	| 'GE'
	| 'GG'
	| 'GH'
	| 'GI'
	| 'GL'
	| 'GM'
	| 'GN'
	| 'GQ'
	| 'GR'
	| 'GT'
	| 'GU'
	| 'GW'
	| 'GY'
	| 'HK'
	| 'HN'
	| 'HR'
	| 'HT'
	| 'HU'
	| 'ID'
	| 'IE'
	| 'IL'
	| 'IM'
	| 'IN'
	| 'IO'
	| 'IQ'
	| 'IR'
	| 'IS'
	| 'IT'
	| 'JE'
	| 'JM'
	| 'JO'
	| 'JP'
	| 'KE'
	| 'KG'
	| 'KH'
	| 'KI'
	| 'KM'
	| 'KN'
	| 'KP'
	| 'KR'
	| 'KW'
	| 'KY'
	| 'KZ'
	| 'LA'
	| 'LB'
	| 'LC'
	| 'LI'
	| 'LK'
	| 'LR'
	| 'LS'
	| 'LT'
	| 'LU'
	| 'LV'
	| 'LY'
	| 'MA'
	| 'MC'
	| 'MD'
	| 'ME'
	| 'MG'
	| 'MH'
	| 'MK'
	| 'ML'
	| 'MM'
	| 'MN'
	| 'MO'
	| 'MP'
	| 'MQ'
	| 'MR'
	| 'MS'
	| 'MT'
	| 'MU'
	| 'MV'
	| 'MW'
	| 'MX'
	| 'MY'
	| 'MZ'
	| 'NA'
	| 'NE'
	| 'NF'
	| 'NG'
	| 'NI'
	| 'NL'
	| 'NO'
	| 'NP'
	| 'NR'
	| 'NU'
	| 'NZ'
	| 'OM'
	| 'PA'
	| 'PE'
	| 'PF'
	| 'PG'
	| 'PH'
	| 'PK'
	| 'PL'
	| 'PM'
	| 'PN'
	| 'PR'
	| 'PT'
	| 'PW'
	| 'PY'
	| 'QA'
	| 'RE'
	| 'RO'
	| 'RS'
	| 'RU'
	| 'RW'
	| 'SA'
	| 'SB'
	| 'SC'
	| 'SD'
	| 'SE'
	| 'SG'
	| 'SH'
	| 'SI'
	| 'SJ'
	| 'SK'
	| 'SL'
	| 'SM'
	| 'SN'
	| 'SO'
	| 'SR'
	| 'SS'
	| 'ST'
	| 'SV'
	| 'SX'
	| 'SY'
	| 'SZ'
	| 'TC'
	| 'TD'
	| 'TF'
	| 'TG'
	| 'TH'
	| 'TJ'
	| 'TK'
	| 'TL'
	| 'TM'
	| 'TN'
	| 'TO'
	| 'TR'
	| 'TT'
	| 'TV'
	| 'TZ'
	| 'UA'
	| 'UG'
	| 'UM'
	| 'US'
	| 'UY'
	| 'UZ'
	| 'VA'
	| 'VC'
	| 'VE'
	| 'VG'
	| 'VI'
	| 'VN'
	| 'VU'
	| 'WF'
	| 'WS'
	| 'YE'
	| 'YT'
	| 'ZA'
	| 'ZM'
	| 'ZW'

type ExtractColorKeys<T> = T extends { styles: infer C } ? keyof C : never
type ExtractBadgeKeys<T> = keyof T
export type BadgeTypeToColorMap<T> = {
	[K in ExtractBadgeKeys<T>]: ExtractColorKeys<T[K]>
}

export const badgeTypes = {
	pillColor: 'pill-color',
	badgeColor: 'color',
	badgeModern: 'modern',
} as const

export type BadgeTypes = (typeof badgeTypes)[keyof typeof badgeTypes]
